import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = '/api';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('leadex_admin_token', res.data.token);
      localStorage.setItem('leadex_admin_user', JSON.stringify(res.data.admin));
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.brand}>
          <div style={s.logo}>⚙</div>
          <div>
            <div style={s.brandName}>Qlicxo Admin</div>
            <div style={s.brandSub}>Platform Management</div>
          </div>
        </div>

        <h2 style={s.title}>Super Admin Login</h2>
        <p style={s.sub}>Restricted access — platform operators only</p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={s.group}>
            <label style={s.label}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              style={s.input} placeholder="admin@qlicxo.com" required autoFocus />
          </div>
          <div style={s.group}>
            <label style={s.label}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              style={s.input} placeholder="••••••••" required />
          </div>
          <button type="submit" disabled={loading}
            style={{ ...s.btn, opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Signing in…' : 'Sign In to Admin Panel'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  container: { minHeight:'100vh', background:'#0a0c12', display:'flex', alignItems:'center', justifyContent:'center', padding:20 },
  card: { background:'#13151f', border:'1px solid #1e2030', borderRadius:14, padding:'36px 40px', width:'100%', maxWidth:400 },
  brand: { display:'flex', alignItems:'center', gap:12, marginBottom:28 },
  logo: { width:42, height:42, background:'linear-gradient(135deg,#e74c3c,#c0392b)', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 },
  brandName: { color:'#fff', fontSize:17, fontWeight:700 },
  brandSub: { color:'#6b7280', fontSize:11 },
  title: { color:'#fff', fontSize:20, fontWeight:600, marginBottom:4 },
  sub: { color:'#6b7280', fontSize:12, marginBottom:24 },
  error: { background:'#2d1515', border:'1px solid #ef4444', color:'#ef4444', padding:'10px 14px', borderRadius:8, marginBottom:16, fontSize:13 },
  group: { marginBottom:14 },
  label: { display:'block', color:'#9ca3af', fontSize:13, marginBottom:5 },
  input: { width:'100%', padding:'11px 12px', background:'#0a0c12', border:'1px solid #1e2030', borderRadius:8, color:'#fff', fontSize:14, boxSizing:'border-box', outline:'none' },
  btn: { width:'100%', padding:12, background:'linear-gradient(135deg,#e74c3c,#c0392b)', border:'none', borderRadius:8, color:'#fff', fontSize:14, fontWeight:600, cursor:'pointer', marginTop:8 },
};
